module.exports = __webpack_public_path__ + "images/psp/SelfStorage/shutterstock_2390631209-scaled.jpg";